import { INFRACTION_METRIC_FILTER } from "../constants/infraction-metrics.constant";
import {
	INFRACTION_METRIC_TO_OPERATIONAL_FILTER,
	INFRACTION_STATUS_TO_OPERATIONAL_FILTER,
} from "../constants/infraction-operational-filter.constant";
import type {
	InfractionListFilters,
	InfractionMetricFilter,
} from "../types/infraction.types";
import type { InfractionPaginatedRequest } from "../types/infraction-api.types";

export function resolveOperationalStatuses(
	metricFilter: InfractionMetricFilter,
	filters: InfractionListFilters
): number[] {
	const statuses = new Set<number>();

	if (metricFilter !== INFRACTION_METRIC_FILTER.ALL) {
		statuses.add(INFRACTION_METRIC_TO_OPERATIONAL_FILTER[metricFilter]);
	}

	if (filters.status !== "all") {
		const operationalStatus =
			INFRACTION_STATUS_TO_OPERATIONAL_FILTER[filters.status];

		if (operationalStatus !== undefined) {
			statuses.add(operationalStatus);
		}
	}

	return Array.from(statuses);
}

export function buildInfractionPaginatedRequest(
	filters: InfractionListFilters,
	metricFilter: InfractionMetricFilter,
	pageNumber: number,
	pageSize: number
): InfractionPaginatedRequest {
	const operationalStatuses = resolveOperationalStatuses(metricFilter, filters);
	const search = filters.search.trim();
	const hasCompleteDeadlineRange = Boolean(
		filters.deadlineStartDate && filters.deadlineEndDate
	);

	return {
		...(search ? { search } : {}),
		...(operationalStatuses.length > 0 ? { operationalStatuses } : {}),
		...(hasCompleteDeadlineRange
			? {
					deadlineStartDate: filters.deadlineStartDate as string,
					deadlineEndDate: filters.deadlineEndDate as string,
				}
			: {}),
		pageNumber,
		pageSize,
		sortBy: "OccurredAt",
		sortDirection: "desc",
	};
}

export function hasActiveInfractionFilters(
	filters: InfractionListFilters,
	metricFilter: InfractionMetricFilter
): boolean {
	if (metricFilter !== INFRACTION_METRIC_FILTER.ALL) {
		return true;
	}

	if (filters.search.trim() !== "") {
		return true;
	}

	if (filters.status !== "all") {
		return true;
	}

	if (filters.deadlineStartDate !== null && filters.deadlineEndDate !== null) {
		return true;
	}

	return false;
}
